import { i18nStore, type SupportedLanguage } from "./i18nStore.js";

export const useTranslation = () => ({
  t: i18nStore.t,
  language: i18nStore.language,
  setLanguage: (language: SupportedLanguage) => i18nStore.setLanguage(language),
});
